import { useQuery } from '@tanstack/react-query'

import type { TeamResponse } from '@/api/generated'
import { getEnterpriseTeams } from '@/api/teamMembersTable'

export const enterpriseTeamsQueryKey = (enterpriseId: string) => ['enterprise-teams', enterpriseId]

// A query key is a contract on the cached shape, not just the URL: consumers that
// inlined their own queryFn cached the bare array and `{ teams }` under this key,
// so whoever mounted first decided which half of the app crashed.
export const useEnterpriseTeams = (enterpriseId: string, { enabled = true }: { enabled?: boolean } = {}) =>
  useQuery<TeamResponse[]>({
    queryKey: enterpriseTeamsQueryKey(enterpriseId),
    queryFn: async ({ signal }) => (await getEnterpriseTeams(enterpriseId, signal)).data.teams,
    enabled: Boolean(enterpriseId) && enabled,
    staleTime: 5 * 60 * 1000,
  })
